import React, { useState, useEffect } from "react";
//Kendo Imports
import { Grid, GridColumn as Column, setSelectedState } from "@progress/kendo-react-grid";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
//Contexts
import { useProject } from '../../contexts/ProjectContext';
import { useEnvironmentConfigContext } from '../../contexts/EnvironmentConfigContext';
//Misc
import loadinggif from "../../assets/loading.gif";
import noaccess from "../../assets/images/noaccess.png";
//Internal Components
import PoleInspectionChart from "./charts/pole_impection_chart";
import PoleRestorationChart from "./charts/pole_restoration_chart";
import DateRangeChartSearch from "./charts/date_range_chart_search";
import PoleUndergroundChart from "./charts/pole_underground_chart";

function ReliabilityDashboard() {
    //arrays of data for graphs
    const [totalRejectCount, setTotalRejectCount] = useState([]);
    const [totalRejectPercent, setTotalRejectPercent] = useState([]);
    const [predictiveChartData, setPredictiveChartData] = useState([]);
    const [predictiveCategories, setPredictiveCategories] = useState([]);
    const [inspectionType, setInspectionType] = useState([]);
    //Restoration graphs states
    const [steelSize, setSteelSize] = useState([]);
    const [noRestoreReason, setNoRestoreReason] = useState([]);
    // underground
    const [rejectInt, setRejectInt] = useState([]);
    const [rejectExt, setRejectExt] = useState([]);
    const [rejectReaX, setRejectReaX] = useState([]);
    const [rejectReaY, setRejectReaY] = useState([]);

    const [rejectIntX, setRejectIntX] = useState([]);
    const [rejectExtX, setRejectExtX] = useState([]);

    //arrays of strings for graph labels
    const [totalRejectCat, setTotalRejectCat] = useState([]);
    const [percentRejectCat, setPercentRejectCat] = useState([]);
    const [steelSizeCategories, setSteelSizeCategories] = useState([]);
    const [noRestoreReasonCategories, setNoRestoreReasonCategories] = useState([]);

    //Project context
    const { selectedProject, GCP_Project, Dataset_ID } = useProject();
    const { environmentConfig } = useEnvironmentConfigContext();

    //util classes
    const [loading, setLoading] = useState(true);
    const [nodata, setNodata] = useState(false);
    const [selectedTab, setSelectedTab] = useState(0);

    useEffect(() => {
        if (selectedProject && GCP_Project && Dataset_ID) {
            getChartData();
        }
    }, [selectedProject, GCP_Project, Dataset_ID]);

    function changeSelectedTab(event) {
        setSelectedTab(event.selected);
    }

    function calculatePercent(count, total) {
        return ((count / total) * 100).toFixed(2)
    }

    function generateRandomHexValue() {
        let ret = "";
        for (let i = 0; i < 6; ++i) {
            const rng = Math.floor(Math.random() * 16);
            ret += rng.toString();
        }
        return ret;
    }

    function getChartData(start = undefined, end = undefined) {
        setLoading(true);
        try {
            fetch(process.env.REACT_APP_WEB_API_URL + '/api-common/Secrets/GetNimblyWebAPIKey', {
                method: 'GET',
                headers: { 'frontendenvironmentconfig': environmentConfig, 'Content-Type': 'application/json', "Access-Control-Allow-Origin": "*" },
                //mode: 'no-cors',
            })
                .then((res) => {
                    return res.text();;
                })
                .then((data) => {
                    //console.log(data);
                    fetch(process.env.REACT_APP_WEB_API_URL + '/api-common/poles/GetReliabilityUGChart', {
                        method: 'POST',
                        headers: { 'frontendenvironmentconfig': environmentConfig, 'Content-Type': 'application/json', 'ApiKey': data, },
                        body: JSON.stringify({
                            rawQuery: "",
                            Project: selectedProject,
                            GCP_Project: GCP_Project, //CHANGE FOR PROD
                            Dataset_ID: Dataset_ID,
                            Start: start,
                            End: end
                        })
                    })
                        .then((res) => {
                            if (!res.ok) {
                                setNodata(true);
                                setLoading(false);
                                throw new Error('This project has no data to display');
                            }
                            setNodata(false);
                                return res.json();;
                        })
                        .then((data) => {
                            // console.log(data);
                            let tempCount = [];
                            let tempPercent = [];
                            let tempCountCat = [];
                            let tempPercentCat = [];
                            let tempInspection = [];
                            let tempRejectIntX = [];
                            let tempRejectExtX = [];
                            let tempRejectIntY = [];
                            let tempRejectExtY = [];
                            let tempRejectReasonX = [];
                            let tempRejectReasonY = [];

                            Object.keys(data.CategoryToCount).forEach(key => {
                                tempCountCat.push(key);
                                tempCount.push(data.CategoryToCount[key].Item1);
                                tempPercentCat.push(key);
                                tempPercent.push(data.CategoryToCount[key].Item2);
                            });

                            // const definedOrder = ['Restorable Reject', 'Non Restorable Reject','Priority Restorable Reject', 'Priority Non Restorable Reject']; 
                            // const dataKeys = Object.keys(data.CategoryToCount);

                            // const remainingKeys = dataKeys.filter(key => !definedOrder.includes(key));
                            // const finalOrder = [...definedOrder, ...remainingKeys];

                            // finalOrder.forEach(key => {
                            //     // Check if the key actually exists in your data to prevent errors
                            //     if (data.CategoryToCount[key]) {
                            //         const item = data.CategoryToCount[key];

                            //         tempCountCat.push(key);
                            //         tempCount.push(item.Item1);

                            //         tempPercentCat.push(key);
                            //         tempPercent.push(item.Item2);
                            //     }
                            // });

                            Object.keys(data.TempRejectExternal).forEach(key => {
                                tempRejectExtX.push(key);
                                tempRejectExtY.push(data.TempRejectExternal[key]);
                            });
                            Object.keys(data.TempRejectInternal).forEach(key => {
                                tempRejectIntX.push(key);
                                tempRejectIntY.push(data.TempRejectInternal[key]);
                            });

                            Object.keys(data.TempRejectReason).forEach(key => {
                                tempRejectReasonX.push(key);
                                tempRejectReasonY.push(data.TempRejectReason[key]);
                            });

                            let l = 0;
                            Object.keys(data.CategoryToInspection).forEach(key => {
                                l += data.CategoryToInspection[key];
                            });

                            const colors = ['#FF5733', '#FFD700', '#1E90FF', '#32CD32', '#FFA500', '#800080', '#FF6347', '#FFFF00', '#0000CD', '#00FF00'];
                            let i = 0;
                            Object.keys(data.CategoryToInspection).forEach(key => {
                                if(key !== "No Type"){
                                    tempInspection.push({
                                        category: key,
                                        count: data.CategoryToInspection[key],
                                        percent: calculatePercent(data.CategoryToInspection[key], l),
                                        color: i < colors.length ? colors[i++] : generateRandomHexValue()
                                    });
                                }
                            });

                            const chartData = data.AnalyticsChartData.map((item) => ({
                                category: item.RejectionStatus || "Unknown",
                                EstimatedCounts: item.EstimatedCounts,
                                TotalCountYTD: item.TotalCountYTD,
                            }));
                            const categories = data.AnalyticsChartData.map((item) => item.RejectionStatus || "Unknown");

                            // const definedOrderProjected = ['Restorable Reject', 'Non Restorable Reject','Priority Restorable Reject', 'Priority Non Restorable Reject']; 

                            // const rawChartData = data.AnalyticsChartData.map((item) => ({
                            //     category: item.RejectionStatus || "Unknown",
                            //     EstimatedCounts: item.EstimatedCounts,
                            //     TotalCountYTD: item.TotalCountYTD,
                            // }));

                            // const sortedChartData = rawChartData.sort((a, b) => {
                            //     let indexA = definedOrderProjected.indexOf(a.category);
                            //     let indexB = definedOrderProjected.indexOf(b.category);

                            //     if (indexA === -1) indexA = definedOrderProjected.length + rawChartData.indexOf(a);
                            //     if (indexB === -1) indexB = definedOrderProjected.length + rawChartData.indexOf(b);

                            //     return indexA - indexB;
                            // });

                            // const sortedCategories = sortedChartData.map((item) => item.category);

                            setTotalRejectCount(tempCount);
                            setTotalRejectPercent(tempPercent);
                            setInspectionType(tempInspection);
                            setTotalRejectCat(tempCountCat);
                            setPercentRejectCat(tempPercentCat);
                            setPredictiveChartData(chartData);
                            setPredictiveCategories(categories);
                            //restoration
                            setSteelSize(Object.values(data.SteelSize));
                            setNoRestoreReason(Object.values(data.NotRestoredReason));
                            setSteelSizeCategories(Object.keys(data.SteelSize));
                            setNoRestoreReasonCategories(Object.keys(data.NotRestoredReason));
                            // Underground
                            setRejectInt(tempRejectIntY);
                            setRejectExt(tempRejectExtY);
                            setRejectIntX(tempRejectIntX);
                            setRejectExtX(tempRejectExtX);
                            setRejectReaX(tempRejectReasonX);
                            setRejectReaY(tempRejectReasonY);
                            setLoading(false);
                        });
                });
        } catch (ex) {
            console.log("<------------------------------>");
            console.log("Error fetching chart data for rs");
            console.error(ex);
        } 
    }

    const NoData = (
        <>
            <img className='pulse-no-access-image' src={noaccess} />
            <h3 className='pulse-no-access-image-text'>This project does not have any data yet.</h3>
        </>
    );

    //Component payload
    function Payload() {
        return (
            nodata
                ? NoData
                : <div className="ken-nimbly-ov-page-content-wrapper">
                    <TabStrip selected={selectedTab} onSelect={(event) => changeSelectedTab(event)}>
                        <TabStripTab title="POLE INSPECTION">
                            <div className="rs-restoration-charts-w">
                                <div className="pulse-dashboard-chart-title">
                                    <p className="pulse-chart-main-title">Chart View:</p>
                                </div>
                                <div className="pulse-dashboard-chart-grid">
                                    <PoleInspectionChart
                                        totalRejectCat={totalRejectCat}
                                        percentRejectCat={percentRejectCat}
                                        totalRejectCount={totalRejectCount}
                                        totalRejectPercent={totalRejectPercent}
                                        predictiveCategories={predictiveCategories}
                                        predictiveChartData={predictiveChartData}
                                        inspectionType={inspectionType}
                                    />
                                </div>
                            </div>
                        </TabStripTab>
                        <TabStripTab title="POLE RESTORATION">
                            {/*As of right now, the containers are different widths due to the grid in the Inspection charts*/}
                            <div className="rs-restoration-charts-wrapper">
                                <div className="pulse-dashboard-chart-title">
                                    <p className="pulse-chart-main-title">Chart View:</p>
                                </div>
                                <div className="pulse-dashboard-chart-grid">
                                    <PoleRestorationChart
                                        steelSizeCount={steelSize}
                                        noRestoreReasonCount={noRestoreReason}
                                        steelSizeCat={steelSizeCategories}
                                        noRestoreResonCat={noRestoreReasonCategories}
                                    />
                                </div>
                            </div>
                        </TabStripTab>
                        <TabStripTab title="UNDERGROUND">
                            <div className="rs-restoration-charts-wrapper">
                                <div className="pulse-dashboard-chart-title">
                                    <p className="pulse-chart-main-title">Chart View:</p>
                                    <p className="pulse-chart-main-sub-title">Underground</p>
                                </div>
                                <div className="pulse-dashboard-chart-grid">
                                    <PoleUndergroundChart
                                        totalRejectCat={totalRejectCat}
                                        percentRejectCat={percentRejectCat}
                                        totalRejectCount={totalRejectCount}
                                        totalRejectPercent={totalRejectPercent}
                                        predictiveCategories={predictiveCategories}
                                        predictiveChartData={predictiveChartData}
                                        inspectionType={inspectionType}
                                        rejectExt={rejectExt}
                                        rejectInt={rejectInt}
                                        rejectIntX={rejectIntX}
                                        rejectExtX={rejectExtX}
                                        rejectReaX={rejectReaX}
                                        rejectReaY={rejectReaY}

                                    />
                                </div>
                            </div>
                        </TabStripTab>
                    </TabStrip>
                </div> 
        );
    }

    return loading ? <img className='nimbly2-loader-gif' src={loadinggif} /> : <Payload />;
}

export default ReliabilityDashboard;